import React, { useState } from "react";
import product from '../../images/shop/product.png';
import product2 from '../../images/shop/product2.png';
import { Link } from "react-router-dom";
import ProductCard from "../products/ProductCard";
import ProductSlider from "../products/ProductSlider";

type Product = {
  id: number;
  title: string;
  price: number;
  rating: number;
  reviews: number;
  image: string;
  category: string;
  isFavorite?: boolean;
  isBestBuy?: boolean;
};

const categories = ["Monitori", "Računari", "Kućišta", "Napajanja", "CPU kuleri"];

const mockProducts: Product[] = [
  {
    id: 1,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product, // replace with actual image path
    category: "Monitori",
    isBestBuy: true,
    isFavorite: false,
  },
  {
    id: 2,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product,
    category: "Monitori",
    isFavorite: true,
  },
  {
    id: 3,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product,
    category: "Monitori",
    isFavorite: false,
  },
  {
    id: 4,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 20,
    image: product,
    category: "Monitori",
    isFavorite: false,
  },
  {
    id: 5,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product2, // replace with actual image path
    category: "Računari",
    isFavorite: false,
  },
  {
    id: 6,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 21,
    image: product2,
    category: "Računari",
    isFavorite: false,
  },
  {
    id: 7,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product2,
    category: "Računari",
    isFavorite: false,
  },
  {
    id: 8,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 12,
    image: product2,
    category: "Računari",
    isFavorite: false,
  },
  {
    id: 9,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product, // replace with actual image path
    category: "Kućišta",
    isFavorite: true,
  },
  {
    id: 10,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 16,
    image: product,
    category: "Kućišta",
    isFavorite: false,
  },
  {
    id: 11,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product,
    category: "Kućišta",
    isFavorite: true,
  },
  {
    id: 12,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 1,
    image: product,
    category: "Kućišta",
    isFavorite: false,
  },
  {
    id: 13,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product2, // replace with actual image path
    category: "Napajanja",
    isFavorite: true,
  },
  {
    id: 14,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 4,
    image: product2,
    category: "Napajanja",
    isFavorite: false,
  },
  {
    id: 15,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product2,
    category: "Napajanja",
    isFavorite: true,
  },
  {
    id: 16,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product2,
    category: "Napajanja",
    isFavorite: false,
  },
  {
    id: 17,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 5,
    image: product, // replace with actual image path
    category: "CPU kuleri",
    isFavorite: true,
  },
  {
    id: 18,
    title: "ZUS238GMG",
    price: 145,
    rating: 3.5,
    reviews: 7,
    image: product,
    category: "CPU kuleri",
    isFavorite: true,
  },
  {
    id: 19,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 25,
    image: product,
    category: "CPU kuleri",
    isFavorite: false,
  },
  {
    id: 20,
    title: "ZUS238GMG",
    price: 145,
    rating: 4.5,
    reviews: 4,
    image: product,
    category: "CPU kuleri",
    isFavorite: false,
  },
  // Add products for other categories
];

const ProductTabs: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<string>("Monitori");

  const filteredProducts = mockProducts.filter(
    (product) => product.category === activeCategory
  );

  return (
    <div className="container mx-auto w-[calc(100%-30px)] px-6 py-10 bg-gray-50 md:flex md:space-x-6 md:bg-[#e8e8e8] rounded-lg">
      <div className="w-full mb-8 md:w-[180px] md:h-full categories-wrapper overflow-x-scroll my-auto">
        <div className="flex flex-row md:flex-col gap-3 items-center h-full">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`px-5 py-2 rounded-md font-medium whitespace-nowrap ${
                activeCategory === cat
                  ? "bg-orange-400 text-white"
                  : "bg-gray-400 text-white"
              } md:px-4 md:py-1.5 w-[150px] md:text-sm md:w-full md:rounded-3xl`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      <div className="w-full md:w-[calc(75%+50px)] md:max-w-[1150px]">
        <ProductSlider products={filteredProducts} />
      </div>
    </div>
  );
};

export default ProductTabs;